/* eslint-disable import/no-unresolved */
const formHelpers = require('base/checkout/formErrors');
const utils = require('onestic-base/utils');

function sendNewsletter() {
    $('body').on('submit', '#newsletterWithCheckbox', (e) => {
        const $form = $(e.target);
        e.preventDefault();

        if ($('#newsletter-terms')[0].checked) {
            $.spinner().start();
            const url = $form.attr('action');
            const formData = {
                format: 'ajax',
                hpEmailSignUp: $('#hpEmailSignUp').val(),
            };

            $.ajax({
                url,
                type: 'post',
                dataType: 'json',
                data: formData,
                success(data) {
                    if (data.error && data.fieldErrors.length) {
                        data.fieldErrors.forEach((error) => {
                            if (Object.keys(error).length) {
                                formHelpers.loadFormErrors('#newsletterWithCheckbox', error);
                                let titleError;

                                try {
                                    titleError = JSON.parse(error.hpEmailSignUp).title;
                                } catch (err) {
                                    titleError = error.hpEmailSignUp;
                                }

                                $('.newsletter-inputs > .invalid-feedback')
                                    .fadeTo(0, 1)
                                    .html(titleError);
                                $('.newsletter-inputs > .input-group').addClass('inputError');
                            }
                        });
                    } else {
                        $('#hpEmailSignUp')
                            .parent()
                            .html(`<span>${data.subscriptiondMsgBody}</span>`);
                        $('.newsletter-inputs > .invalid-feedback').fadeTo(0, 0);
                        $('.newsletter-inputs > .input-group').removeClass('inputError');
                    }
                    $.spinner().stop();
                },
                error(err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $.spinner().stop();
                },
            });
        } else {
            $('.newsletter-inputs > .invalid-feedback').fadeTo(0, 1);
            $('.newsletter-inputs > .input-group').addClass('inputError');
        }
        return false;
    });
}

function makeNewsletterReady() {
    const newsletterContainer = $('.home-newsletter');

    if (newsletterContainer.hasClass('modal')) {
        const consentTrackingContainer = $('.consent-tracking');
        const cookie = utils.getCookie('newsletterModal');

        if (cookie.length === 0) {
            if (consentTrackingContainer.css('display') === 'none') {
                newsletterContainer.modal();
                sendNewsletter();
            } else {
                consentTrackingContainer.find('.button-wrapper button').click(() => {
                    newsletterContainer.modal();
                    sendNewsletter();
                });
            }

            newsletterContainer.on('hidden.bs.modal', () => {
                $('.embed-responsive-item').attr('src', '');

                utils.setCookie('newsletterModal');
            });

            newsletterContainer.find('.close-modal', () => {
                utils.setCookie('newsletterModal');
            });
        }
    } else {
        sendNewsletter();
    }
}

module.exports = () => {
    makeNewsletterReady();
    $('body').on('submit', '#newsletter', (e) => {
        const $form = $(e.target);
        e.preventDefault();
        const url = $form.attr('action');
        const formData = {
            format: 'ajax',
            hpEmailSignUp: $('#hpEmailSignUp').val(),
        };

        $.ajax({
            url,
            type: 'post',
            dataType: 'json',
            data: formData,
            success(data) {
                if (data.error) {
                    if (data.fieldErrors.length) {
                        data.fieldErrors.forEach((error) => {
                            if (Object.keys(error).length) {
                                formHelpers.loadFormErrors('#newsletter', error);
                            }
                        });
                    }
                } else {
                    const hpEmailSignUp = $('#hpEmailSignUp');
                    hpEmailSignUp
                        .parents('.newsletter-inputs')
                        .find('.check-terms').hide();
                    hpEmailSignUp
                        .parent()
                        .html(`<span>${data.subscriptiondMsgBody}</span>`);
                    $('.newsletter-inputs-container').addClass('d-flex align-items-center');
                }
            },
            error(err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            },
        });
        return false;
    });
};
